import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../data/offer';
type FloatingCtaProps = {
  anchorId: string;
};
export function FloatingCta({
  anchorId
}: FloatingCtaProps) {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const anchor = document.getElementById(anchorId);
    if (!anchor) return;
    const observer = new IntersectionObserver(([entry]) => {
      setVisible(!entry.isIntersecting && entry.boundingClientRect.top < 0);
    });
    observer.observe(anchor);
    return () => observer.disconnect();
  }, [anchorId]);
  return <AnimatePresence data-id="element-38" data-mp="br2e14kk8t7t">
      {visible && <motion.div className="fixed inset-x-0 bottom-0 z-40 px-3 pb-3 pt-2 sm:pb-5" initial={{
      y: '110%'
    }} animate={{
      y: 0
    }} exit={{
      y: '110%'
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} data-id="element-39" data-mp="bq9hewfbfk3e">
          <a href={CHECKOUT_URL} className="mx-auto flex w-full max-w-md animate-shake items-center justify-center gap-2 rounded-2xl border-2 border-navy-950 bg-gold px-4 py-4 font-display text-base font-black uppercase tracking-tight text-navy-950 shadow-[0_8px_24px_rgba(5,15,44,0.35)] focus-visible:outline focus-visible:outline-4 focus-visible:outline-electric motion-reduce:animate-none sm:text-lg" data-id="element-40" data-mp="2b1xfkxdi6isr">
            Get everything for $27
            <ArrowRightIcon className="h-5 w-5" strokeWidth={3} aria-hidden="true" data-id="element-41" data-mp="1wdjcqmg36uc7" />
          </a>
        </motion.div>}
    </AnimatePresence>;
}